const ENV_LOCAL = 'local';
const ENV_PROD = 'production';

export function isDevOrLocal() {
  return getEnvironmentId() !== ENV_PROD;
}

export function getEnvironmentId() {
  return process.env.REACT_APP_ENVIRONMENT || ENV_LOCAL;
}

export function getRevisionId() {
  return process.env.REACT_APP_REVISION || null;
}

export function isLocal() {
  return getEnvironmentId() === ENV_LOCAL;
}



// WEBPACK FOOTER //
// ./src/app/utils/env.js